import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/homePage.vue'
import DiseaseAnalysisPage from '@/views/DiseaseAnalysisPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/disease-analysis',
    name: 'DiseaseAnalysisPage',
    component: DiseaseAnalysisPage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router